// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Attractions Component Animations */

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Auto scrolling animation */
@keyframes autoScroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.attractions-container {
  overflow: hidden;
  position: relative;
  padding: 20px 0;
}

.attractions-scroll {
  display: flex;
  animation: autoScroll 20s linear infinite;
  width: 200%;
}

.attractions-scroll:hover {
  animation-play-state: paused;
}

.attraction-card {
  flex: 0 0 12%;
  padding: 0 10px;
  animation: fadeInScale 0.6s ease-out;
}

.attraction-card:nth-child(1) {
  animation-delay: 0.1s;
}

.attraction-card:nth-child(2) {
  animation-delay: 0.2s;
}

.attraction-card:nth-child(3) {
  animation-delay: 0.3s;
}

.attraction-card:nth-child(4) {
  animation-delay: 0.4s;
}

.attraction-card:nth-child(5) {
  animation-delay: 0.5s;
}

.attraction-card:nth-child(6) {
  animation-delay: 0.6s;
}

.hover-lift {
  transition: all 0.4s ease;
}

.hover-lift:hover {
  transform: translateY(-15px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.attraction-image {
  transition: all 0.4s ease;
  position: relative;
  overflow: visible;
}

.attraction-image::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.8s ease;
  z-index: 2;
}

.hover-lift:hover .attraction-image::before {
  left: 100%;
}

.attraction-image img {
  width: 100%;
  height: 500px;
  object-fit: fill !important;
  display: block;
  border-radius: 1rem;
  background-color: #f8f9fa;
}

.attraction-overlay {
  background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.8) 100%);
  transition: all 0.3s ease;
}

.hover-lift:hover .attraction-overlay {
  background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.9) 100%);
}

.attraction-badge {
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.1);
}

.hover-lift:hover .attraction-badge {
  background: rgba(255,255,255,0.3) !important;
  transform: translateY(-5px);
  border: 1px solid rgba(255,255,255,0.3);
}

.section-header {
  animation: slideInUp 1s ease-out;
}

.cta-button {
  animation: pulse 2s infinite;
  transition: all 0.3s ease;
}

.cta-button:hover {
  animation: none;
  transform: translateY(-5px) scale(1.05);
  box-shadow: 0 15px 30px rgba(0,0,0,0.2);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .attractions-scroll {
    animation-duration: 15s;
  }
  
  .attraction-card {
    flex: 0 0 35%;
  }
  
  .hover-lift {
    animation-duration: 4s;
  }
}

@media (max-width: 576px) {
  .attraction-card {
    flex: 0 0 50%;
  }
}

/* Pause animation on reduced motion preference */
@media (prefers-reduced-motion: reduce) {
  .attractions-scroll,
  .hover-lift,
  .cta-button {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Landingpage/Attractions.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yEAAyE;EACzE,yBAAyB;AAC3B;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA,2BAA2B;AAC3B;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,iDAAiD;AACjD;EACE;;;IAGE,eAAe;EACjB;AACF","sourcesContent":["/* Attractions Component Animations */\n\n@keyframes slideInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Auto scrolling animation */\n@keyframes autoScroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.attractions-container {\n  overflow: hidden;\n  position: relative;\n  padding: 20px 0;\n}\n\n.attractions-scroll {\n  display: flex;\n  animation: autoScroll 20s linear infinite;\n  width: 200%;\n}\n\n.attractions-scroll:hover {\n  animation-play-state: paused;\n}\n\n.attraction-card {\n  flex: 0 0 12%;\n  padding: 0 10px;\n  animation: fadeInScale 0.6s ease-out;\n}\n\n.attraction-card:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.attraction-card:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.attraction-card:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.attraction-card:nth-child(4) {\n  animation-delay: 0.4s;\n}\n\n.attraction-card:nth-child(5) {\n  animation-delay: 0.5s;\n}\n\n.attraction-card:nth-child(6) {\n  animation-delay: 0.6s;\n}\n\n.hover-lift {\n  transition: all 0.4s ease;\n}\n\n.hover-lift:hover {\n  transform: translateY(-15px);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);\n  z-index: 10;\n}\n\n.attraction-image {\n  transition: all 0.4s ease;\n  position: relative;\n  overflow: visible;\n}\n\n.attraction-image::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  transition: left 0.8s ease;\n  z-index: 2;\n}\n\n.hover-lift:hover .attraction-image::before {\n  left: 100%;\n}\n\n.attraction-image img {\n  width: 100%;\n  height: 500px;\n  object-fit: fill !important;\n  display: block;\n  border-radius: 1rem;\n  background-color: #f8f9fa;\n}\n\n.attraction-overlay {\n  background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.8) 100%);\n  transition: all 0.3s ease;\n}\n\n.hover-lift:hover .attraction-overlay {\n  background: linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.9) 100%);\n}\n\n.attraction-badge {\n  transition: all 0.3s ease;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255,255,255,0.1);\n}\n\n.hover-lift:hover .attraction-badge {\n  background: rgba(255,255,255,0.3) !important;\n  transform: translateY(-5px);\n  border: 1px solid rgba(255,255,255,0.3);\n}\n\n.section-header {\n  animation: slideInUp 1s ease-out;\n}\n\n.cta-button {\n  animation: pulse 2s infinite;\n  transition: all 0.3s ease;\n}\n\n.cta-button:hover {\n  animation: none;\n  transform: translateY(-5px) scale(1.05);\n  box-shadow: 0 15px 30px rgba(0,0,0,0.2);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .attractions-scroll {\n    animation-duration: 15s;\n  }\n  \n  .attraction-card {\n    flex: 0 0 35%;\n  }\n  \n  .hover-lift {\n    animation-duration: 4s;\n  }\n}\n\n@media (max-width: 576px) {\n  .attraction-card {\n    flex: 0 0 50%;\n  }\n}\n\n/* Pause animation on reduced motion preference */\n@media (prefers-reduced-motion: reduce) {\n  .attractions-scroll,\n  .hover-lift,\n  .cta-button {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
